import {useEffect, useState} from 'react';
import {useDangerousHooks} from '@packages/systems/wfdl';

const MAX_ATTEMPTS = 10;

export const useNativeNode = (): HTMLElement | null => {
  const {getNativeNode} = useDangerousHooks();
  const currentNativeNode = getNativeNode();
  const [nativeNode, setNativeNode] = useState(currentNativeNode);

  useEffect(() => {
    if (nativeNode && nativeNode === currentNativeNode) return;

    let attempts = 0;
    let frame: number;
    const check = () => {
      const next = getNativeNode();
      setNativeNode(next);
      attempts += 1;
      if (next == null && attempts < MAX_ATTEMPTS) {
        frame = requestAnimationFrame(check);
      }
    };
    frame = requestAnimationFrame(check);

    return () => cancelAnimationFrame(frame);
  }, [nativeNode, currentNativeNode, getNativeNode]);

  return nativeNode;
};
